enum BrandTypes {
  VERY = 'very',
  VERYIE = 'veryie',
  LITTLEWOODS = 'littlewoods',
}

export default BrandTypes;
